<template>
  <div>
    <label :for="name" class="">
      <span v-if="showLabel" class="input-label">{{ label }}</span>
      <div class="input-container">
        <EmptyStateFramed
          class="border-none"
          :title="title"
          :text="text"
          :iconClass="iconClass"
        />
        <input
          :multiple="allowMultiple"
          class="invisible w-0 h-0 overflow-hidden absolute"
          :accept="allowedFileTypes"
          type="file"
          :name="name"
          :id="name"
          @input="getFile($event)"
        />
      </div>
    </label>
    <div class="input-file-preview-container">
      <div
        v-for="(file, index) in files"
        v-show="showFile"
        :key="index"
        class="input-file-preview"
      >
        <figure class="relative h-56 w-full">
          <img
            class="absolute w-full h-full object-cover"
            :src="file.path"
            alt=""
          />
        </figure>
        <div class="bottom-part flex items-center justify-between px-4 py-2">
          <div class="flex items-center">
            <i :class="[iconClass, 'bx text-teal-base']"></i>
            <p class="input-file-name">{{ file.name }}</p>
          </div>
          <button type="button" class="btn-remove" @click="removeFile(index)">
            <i class="bx bx-trash"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EmptyStateFramed from "@/components/EmptyStates/EmptyStateFramed";
export default {
  name: "InputUpload",
  components: {
    EmptyStateFramed,
  },
  data() {
    return {
      showFile: false,
      files: [],
      allFiles: [],
    };
  },
  props: {
    allowedFileTypes: {
      type: String,
      default: ".jpg, .jpeg, .png, .pdf",
    },
    iconClass: {
      type: String,
      default: "bx-image-alt",
    },
    title: {
      type: String,
      default: "Title",
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    showDescription: {
      type: Boolean,
      default: false,
    },
    description: {
      type: String,
      default: "Description",
    },
    label: {
      type: String,
      default: "Label",
    },
    text: {
      type: String,
      default: "Text",
    },
    name: {
      type: String,
      default: "file",
    },

    allowMultiple: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    getFile(event) {
      //Set FileList array in a variable
      let uploadedFiles = event.target.files;

      this.allFiles = [...event.target.files, ...this.allFiles];
      //Push the files in the Files Array
      this.files = [...uploadedFiles, ...this.files];

      //Create blob filepath for preview
      for (let file of this.files) {
        let filePath = URL.createObjectURL(file);
        file.path = filePath;
      }

      //Show uploaded files if files array isn't empty
      if (this.files.length > 0) {
        this.showFile = true;
      }

      if (this.allowMultiple) {
        this.$emit("input", this.allFiles);
      } else {
        this.$emit("input", event.target.files[0]);
      }
    },
    removeFile(index) {
      this.files.splice(index, 1);
      this.allFiles.splice(index, 1);
      this.$emit("input", this.allFiles);
    },
  },
};
</script>
<style scoped>
.input-label {
  @apply text-black-base block font-sans font-semibold;
  @apply text-base;
}
.input-container {
  @apply border hover:bg-grey-lighter cursor-pointer mt-3 border-dashed border-grey-dark rounded;
}
.input-file-preview-container {
  @apply grid grid-cols-4 sm:gap-6 w-full;
}

.input-file-preview {
  @apply rounded-md border border-grey-base col-span-full sm:col-span-2 overflow-hidden mt-6;
}

.input-file-name {
  @apply ml-1.5 sm:ml-3 text-base truncate;
}

.btn-remove {
  @apply rounded-full ml-2 text-red-base bg-white w-10 h-8 py-2;
  @apply hover:bg-grey-light transition-all ease-out duration-300;
  @apply flex items-center justify-center;
  @apply border border-grey-base;
}
</style>
